/**
 * @generated SignedSource<<9dd0b8ef821b2a233422b02d07f77e21>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ViewInRoomImageCredits_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useItemDisplayDimensions_user">;
  readonly " $fragmentType": "ViewInRoomImageCredits_user";
};
export type ViewInRoomImageCredits_user$key = {
  readonly " $data"?: ViewInRoomImageCredits_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"ViewInRoomImageCredits_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ViewInRoomImageCredits_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useItemDisplayDimensions_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "b1106e3e53c2bd1432ee2043c5af3c59";

export default node;
